import Vue from 'vue'
import Vuex from 'vuex'
import { assign } from 'lodash'
import modules from './modules'
import pathify from 'vuex-pathify'
import abilityPlugin from './plugins/ability'

Vue.use(Vuex)

/**
 * Create our store object.
 *
 * @type Vuex
 */
const store = new Vuex.Store({
  strict: true,
  plugins: [
    pathify.plugin,
    abilityPlugin
  ],
  actions: {
    reset ({ commit }, state) {
      commit('reset', state)
    }
  },
  mutations: {
    reset (state, initialState) {
      assign(state, initialState)
    }
  },
  modules
})

export { store, modules }
export default store
